import { Component, effect, input, model, output, signal } from '@angular/core';
import { CurrencyDto, SupportedCurrency } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../../edit-wrapper/form-edit-wrapper.component';
import { AuraInternationalizationCurrencyDisplayComponent } from '../display/internationalization-currency-display.component';
import { AuraInternationalizationCurrencyFormComponent } from '../form/internationalization-currency-form.component';

@Component({
  selector: 'aura-internationalization-currency-edit',
  imports: [
    AuraEditWrapperComponent,
    AuraInternationalizationCurrencyFormComponent,
    AuraInternationalizationCurrencyDisplayComponent,
  ],
  templateUrl: './internationalization-currency-edit.component.html',
})
export class AuraInternationalizationCurrencyEditComponent {
  initialCurrency = input.required<SupportedCurrency>();
  isEditing = model<boolean>(false);
  closeEditing = input<boolean>(false);
  saved = output<CurrencyDto>();

  currentCurrency = signal<CurrencyDto | null>(null);

  constructor() {
    effect(() => {
      const currency = this.initialCurrency();
      if (currency) {
        this.currentCurrency.set({ currency });
      }
    });

    effect(() => {
      if (this.closeEditing()) {
        this.isEditing.set(false);
      }
    });
  }
}
